import { render } from "./ArgonPaginationItem.vue?vue&type=template&id=5daa1171"
import script from "./ArgonPaginationItem.vue?vue&type=script&lang=js"
export * from "./ArgonPaginationItem.vue?vue&type=script&lang=js"
script.render = render

export default script